export default __webpack_public_path__ + "static/media/QuATRo_Siegel_2023_Gold.31793ab6.svg";